import { render, staticRenderFns } from "./CanvasToolbarTopPreviewButtons.vue?vue&type=template&id=58c47b99&scoped=true"
import script from "./CanvasToolbarTopPreviewButtons.vue?vue&type=script&lang=ts&setup=true"
export * from "./CanvasToolbarTopPreviewButtons.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CanvasToolbarTopPreviewButtons.vue?vue&type=style&index=0&id=58c47b99&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c47b99",
  null
  
)

export default component.exports